<template>
	<div :class='opened ? "v_dropdown-multiple opened" : "v_dropdown-multiple"'>
		<input
			type="text"
			v-model='activeOpts'
			readonly
			@click='open'
			:placeholder='placeholder'
			:title='activeOpts'
		/>
		<span class="focus-bg"></span>

		<div class="wtf" @click='wtf'></div>

		<div :class='opened ? "options active" : "options"'>
			<div class="overflow">
				<template v-if='options.length'>
					<div
					 	v-for='opt in options'
						:class='activeClass(opt.text) ? "opt active" : "opt"'
						@click='select(opt.text, opt.value, activeClass(opt.text))'>
						{{opt.text}}
					</div>
				</template>
				<template v-else>
					<div class="null"></div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {
	props: [
		'name', 'options', 'placeholder'
	],

	data() {
		return {
			active: [],
			opened: false,
			value: []
		}
	},

	computed: {

		activeOpts() {
			return this.active.join(', ');
		}
	},

	watch: {
		value() {
			this.$emit('changed', {
				[this.name]: this.value
			})
		}
	},

	methods: {
		select(txt, val, active) {
			if(active) {
				for(let i = 0; i < this.active.length; i++) {
					if(txt === this.active[i]) {
						this.active.splice(i, 1);
						break;
					}
				}
			}
			else {
				this.active.push(txt);
				this.value.push(val);
				// console.log(this.value);
			}
		},

		wtf() {
			if(this.opened) {
				this.opened = false;
				this.filter = this.active;
			}
			else {
				this.$el.querySelector('input').click();
			}
		},

		open() {
			this.opened = !this.opened;
		},

		activeClass(txt) {
			let flag = false;

			for(let i = 0; i < this.active.length; i++) {
				if(txt === this.active[i]) {
					flag = true;
					break;
				}
			}

			return flag;
		}
	},

	mounted() {
		document.addEventListener('click', e => {
			if(!$(e.target).closest($(this.$el)).length) {
				this.opened = false;
				this.filter = this.active;
			}
		})
	}
}
</script>

<style lang="scss">
	@import "scss/wanted";
	.v_dropdown-multiple {
		height: 46px;
		border: 1px solid #B3B3B3;
		border-radius: 7px;
		font-size: 15px;
		color: #282828;
		display: flex;
		align-items: center;
		padding: 0 19px;
		position: relative;
		background-color: #fff;

		&:after {
			content: '';
			display: block;
			width: 12px;
			height: 7px;
			position: absolute;
			top: calc(50% - 3px);
			right: 10px;
			background: url('#{$imgPathSCSS}arrow-3.png');
			@include single-transition;
			z-index: 1;
		}

		.wtf {
			display: block;
			width: 12px;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 10px;
			z-index: 2;
			// background-color: rgba(red, .2);
			cursor: pointer;
		}

		&.opened {
			&:after {
				@include rotate(180deg);
			}
			.focus-bg{
				&:before{
					transition: 0.3s;
					width: 50%;
					left: 0;
					top: 0;
					height: 100%;
					z-index: 0;
				}
				&:after{
					transition: 0.3s;
					width: 50%;
					height: 100%;
					bottom: 0;
					right: 0;
					z-index: 0;
				}
			}
		}

		input {
			align-self: stretch;
			border: none;
			font-size: 15px;
			color: #282828;
			text-overflow: ellipsis;
			cursor: pointer;
			padding-right: 10px;
			@include placeholder {
				opacity: 1;
				color: #282828;
			};
		}
		input ~ .focus-bg{
			&:before, &:after{
				content: "";
				position: absolute;
				left: 50%;
				top: 50%;
				width: 0;
				height: 0;
				background-color: rgba(#ededed, .15);
				transition: 0.3s;
				z-index: -1;
			}
			&:after{
				left: auto;
				right: 50%;
				top: auto;
				bottom: 50%;
			}
		}

		.options {
			position: absolute;
			top: 150%;
			left: 0;
			width: 100%;
			background-color: #fff;
			border-radius: 10px;
			z-index: 2;
			border: 1px solid #EFEFEF;
			padding: 10px 0 10px 10px;
			box-shadow: 0px 5px 10px 0px rgba(#000, 0.05);
			@include single-transition;
			opacity: 0;
			@include pointer-events(none);
			@include translateY(10px);

			&.active {
				opacity: 1;
				@include pointer-events(auto);
				@include translateY(0px);
			}

			&:before {
				content: '';
				display: block;
				width: 19px;
				height: 10px;
				// background: url('#{$imgPathSCSS}dda.png') no-repeat center;
				position: absolute;
				left: 10px;
				bottom: calc(100% - 1px);
			}

			.overflow {
				max-height: 200px;
				overflow: auto;
				padding: 0 10px 0 0;
			}

			.null {
				&:after {
					@include fa($fa-frown-o);
					font-size: 20px;
				}
			}

			.opt {
				color: #282828;
				font-size: 15px;
				line-height: 17px;
				border: 1px solid #fff;
				border-radius: 8px;
				margin: 0 0 2px;
				padding: 12px 10px 10px;
				cursor: pointer;
				@include single-transition;
				position: relative;

				&:hover {
					border-color: #ACB1B5;
				}

				&.active {
					border-color: #FF2E2D !important;
					color: #FF2E2D;

					&:after {
						background-image: url('#{$imgPathSCSS}close.png');
					}
				}

				&:after {
					content: '';
					display: block;
					position: absolute;
					width: 10px;
					height: 10px;
					background: url('#{$imgPathSCSS}arrow-2.png') no-repeat center;
					right: 10px;
					top: calc(50% - 5px);
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// dropdown-multiple.vue?7ccef37e